// Basic
import { useState } from 'react';
import PropTypes from 'prop-types';
// Store & actions
import actionsSession from '@/app/modules/session/api/actionsSession';
import useSessionStore from '@/app/store/session';
// Common
import RouteUrls from '@/app/root/enums/RouteUrls';
import { cn } from '@/common-utils/libraries/tailwind/utils';
// Components
import { ModalBody, ModalContent } from '@/common-utils/components/ui/modal';
import HeaderTitle from '@/common-utils/components/renders/modal/components/headers/HeaderTitle/HeaderTitle';
import FooterConfirmation from '@/common-utils/components/renders/modal/components/footers/FooterConfirmation/FooterConfirmation';
import FooterForm from '@/common-utils/components/renders/modal/components/footers/FooterForm/FooterForm';
import Entity from '@/common-utils/components/renders/entity/Entity';
// Css
import './ContentRemoveMFA.scss';
import { nsSession } from '@/app/i18n/namespaces';

/**
 * @param {string} token
 * @returns {JSX} ContentRemoveMFA
 */
function ContentRemoveMFA({ token }) {
    // Store
    const session = useSessionStore((s) => s.session);

    // Constants
    const userEmail = session.email ?? null;

    //  State
    const [responseEntity, setResponseEntity] = useState(null);

    // API call
    const OnSuccess = () => {
        setResponseEntity('mfa.remove_email_warning');
    };
    const OnError = () => {
        setResponseEntity('mfa.remove_send_email_error');
    };
    const sendMfaDeactivationMail = actionsSession.sendMfaDeactivationMail(OnSuccess, OnError);

    // Functions
    const sendMailToRemoveMFA = () => {
        const landingPage = window.location.href?.split('/#/')[1]?.split('?')[0];

        sendMfaDeactivationMail.mutate({
            landingPage: landingPage && landingPage !== '' ? landingPage : RouteUrls.HOME.url,
            token
        });
    };

    return (
        <ModalContent className={cn('max-w-lg', 'modal-secure-access')}>
            <HeaderTitle title='mfa.remove_modal_title' namespace={nsSession} />
            <ModalBody>
                {
                    !responseEntity &&
                    <div>
                        <div>
                            <Entity namespace={nsSession} entity='mfa.remove_text_validation' />
                        </div>
                        <div className='remove-mfa-email-information'>
                            {
                                userEmail ?
                                    <div>
                                        <Entity namespace={nsSession} entity='mfa.remove_email_information' />
                                        <span className='remove-mfa-email'>{userEmail}</span>
                                    </div>
                                    :
                                    <Entity namespace={nsSession} entity='mfa.remove_email_missing' />
                            }
                        </div>
                    </div>
                }
                {responseEntity && <Entity namespace={nsSession} entity={responseEntity} />}
            </ModalBody>
            {responseEntity ?
                <FooterForm showSubmitButton={false} />
                :
                <FooterConfirmation
                    onValidation={sendMailToRemoveMFA}
                    isSubmitDisabled={sendMfaDeactivationMail.isLoading}
                />
            }
        </ModalContent >
    );
}

ContentRemoveMFA.propTypes = {
    token: PropTypes.string
};

export default ContentRemoveMFA;